import { render, staticRenderFns } from "./ClassroomDetailStudentUploadTemplate.vue?vue&type=template&id=4ea8d524&scoped=true"
import script from "./ClassroomDetailStudentUploadTemplate.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailStudentUploadTemplate.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailStudentUploadTemplate.vue?vue&type=style&index=0&id=4ea8d524&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8d524",
  null
  
)

export default component.exports